/** Current published legal document versions (ISO calendar dates as shown in the docs). */
export const LEGAL = {
  termsVersion: 'September 3, 2026',
  privacyVersion: 'September 3, 2026',
  termsEffectiveDate: 'June 1, 2026',
  privacyEffectiveDate: 'June 1, 2026',
  companyName: 'VNash Digital Pvt Ltd',
  companyAddress: 'Bangalore, India',
  contactEmail: 'contact@sapyon.com',
} as const;
